import { BiLoaderCircle } from 'react-icons/bi';
import UserAppContext from '../../hook/UserAppContext';

import './load.css';

const Load = () => {

      const {user} = UserAppContext()
      
      if(user.length !== 0) return;
      
      return (
            <div className="load_content">
                  <div className="load_inner">
                        <div className="load_circle">
                              <BiLoaderCircle />
                        </div>
                        <span>Loading...</span>
                  </div>
            </div>
      )
}

export default Load;